// extracted by mini-css-extract-plugin
export default {"container":"Card_container__IILjD","upload":"Card_upload__Kl0vB","field":"Card_field__IVqAh","placeholder":"Card_placeholder__YilKA"};